import { render, staticRenderFns } from "./CenterProfile.vue?vue&type=template&id=b8e0d3d6&"
import script from "./CenterProfile.vue?vue&type=script&lang=ts&"
export * from "./CenterProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports